import { getStorageKey, setStorageKey } from "../../global/storage";

export function persistValues<T>(
  keysToPersist: Array<keyof T>,
  key: keyof T,
  newValue: T[typeof key],
  oldValue: T[typeof key],
) {
  if (newValue === oldValue) return;

  if (keysToPersist.includes(key)) {
    if (newValue instanceof Set) {
      return setStorageKey(key as StorageKey, JSON.stringify([...newValue]));
    }
    return setStorageKey(key as StorageKey, JSON.stringify(newValue));
  }
}

export interface PersistedStore<T> {
  persistedKeys: Array<keyof T>;
}

export async function restoreStore(storeWithPersistedKeys) {
  const storageResults = await Promise.all(
    storeWithPersistedKeys.persistedKeys.map((key) =>
      getStorageKey(key as StorageKey),
    ),
  );
  let index = 0;
  for (const persistedKey of storeWithPersistedKeys.persistedKeys) {
    storeWithPersistedKeys[persistedKey] = typeof storageResults[index] === undefined ? storeWithPersistedKeys[persistedKey] : JSON.parse(storageResults[index]);
    index++;
  }
}
